"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
const helpers_1 = require("@/app/shared/helpers");
const redux_1 = require("redux");
const actions_1 = require("./actions");
const constants_1 = require("./constants");
const reducerUtils_1 = require("./reducerUtils");
exports.initialState = {
    schedulerData: null,
    workspaceData: null,
    hostSchedule: null,
    isSettingsOpened: false,
    showWeekends: false,
    schedulerParams: {},
    workspaceId: null,
    meetingTypeId: null,
    meetingType: constants_1.DEFAULT_BOOKING_PAGE,
    availability: "OPEN" /* SchedulerAvailability.OPEN */,
    availabilityCustom: [],
    availabilityRange: {},
    availabilityRollingWindow: 10,
    availabilityRollingExpiration: null,
    limit: "UNLIMITED" /* SchedulerLimit.UNLIMITED */,
    calendarStartAt: constants_1.DEFAULT_CALENDAR_START_AT,
    host: null,
    mainGuest: null,
    guests: [],
    upsertAction: null,
    bookAction: null,
    isSchedulerDataFetching: false,
    isWorkspaceDataFetching: false,
    isHostScheduleFetching: false,
    error: false,
    hostScheduleError: false,
    isCreateFetching: false,
    createError: null,
    isBookFetching: false,
    bookError: null,
    headerTab: "OFFER_BOOKING_TIME" /* SchedulerHeaderTab.OFFER_BOOKING_TIME */,
    membersData: [],
    isFetchingMembers: false,
    isBookSuccess: false,
};
const schedulerData = (state = exports.initialState.schedulerData, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.SET_SCHEDULER_DATA:
        case actions_1.SUMO1SchedulerActionTypes.GET_SCHEDULER_DATA_SUCCESS:
            return action.payload;
        case actions_1.SUMO1SchedulerActionTypes.UPDATE_SCHEDULER_DATA:
            return { ...state, ...action.payload };
        case actions_1.SUMO1SchedulerActionTypes.GET_SCHEDULER_DATA_FAILURE:
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.schedulerData;
        default:
            return state;
    }
};
const workspaceData = (state = exports.initialState.workspaceData, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.GET_WORKSPACE_DATA_SUCCESS:
            return action.payload;
        case actions_1.SUMO1SchedulerActionTypes.GET_WORKSPACE_DATA_FAILURE:
            return null;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.workspaceData;
        default:
            return state;
    }
};
const membersData = (state = exports.initialState.membersData, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.ADD_MEMBERS:
            return (0, reducerUtils_1.updateMembersListByEmail)(state, action.payload);
        case actions_1.SUMO1SchedulerActionTypes.CLEAR_MEMBERS:
            return [];
        default:
            return state;
    }
};
const isFetchingMembers = (state = exports.initialState.isFetchingMembers, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.GET_MEMBERS_REQUEST:
            return true;
        case actions_1.SUMO1SchedulerActionTypes.GET_MEMBERS_SUCCESS:
        case actions_1.SUMO1SchedulerActionTypes.GET_MEMBERS_FAIL:
        case actions_1.SUMO1SchedulerActionTypes.CLEAR_MEMBERS:
            return false;
        default:
            return state;
    }
};
const hostSchedule = (state = exports.initialState.hostSchedule, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.GET_HOST_SCHEDULE_SUCCESS:
            return action.payload;
        case actions_1.SUMO1SchedulerActionTypes.GET_HOST_SCHEDULE_FAILURE:
            return null;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.hostSchedule;
        default:
            return state;
    }
};
const isSettingsOpened = (state = exports.initialState.isSettingsOpened, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.SET_IS_SETTINGS_OPENED:
            return action.payload;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isSettingsOpened;
        default:
            return state;
    }
};
const showWeekends = (state = exports.initialState.showWeekends, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.SET_SHOW_WEEKENDS:
            return action.payload;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.showWeekends;
        default:
            return state;
    }
};
const schedulerParams = (state = exports.initialState.schedulerParams, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.SET_SCHEDULER_PARAMS:
            return action.payload;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.schedulerParams;
        default:
            return state;
    }
};
const workspaceId = (state = exports.initialState.workspaceId, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.SET_WORKSPACE_ID:
            return action.payload;
        case actions_1.SUMO1SchedulerActionTypes.GET_SCHEDULER_DATA_SUCCESS:
            return action.payload.workspaceId || state;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.workspaceId;
        default:
            return state;
    }
};
const meetingTypeId = (state = exports.initialState.meetingTypeId, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.SET_MEETING_TYPE_ID:
            return action.payload;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.meetingTypeId;
        default:
            return state;
    }
};
const meetingType = (state = exports.initialState.meetingType, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.UPDATE_BOOKING_PAGE:
            return { ...state, ...action.payload };
        case actions_1.SUMO1SchedulerActionTypes.UPDATE_BOOKING_PAGE_WHAT:
            return {
                ...state,
                what: {
                    ...state.what,
                    ...action.payload,
                },
            };
        case actions_1.SUMO1SchedulerActionTypes.UPDATE_BOOKING_PAGE_WHERE:
            return {
                ...state,
                where: {
                    ...state.where,
                    ...action.payload,
                },
            };
        case actions_1.SUMO1SchedulerActionTypes.UPDATE_BOOKING_PAGE_WHEN:
            return {
                ...state,
                when: {
                    ...state.when,
                    ...action.payload,
                },
            };
        case actions_1.SUMO1SchedulerActionTypes.SET_SCHEDULER_PARAMS:
            return {
                ...state,
                what: {
                    ...state.what,
                    customName: action.payload.subject,
                },
            };
        case actions_1.SUMO1SchedulerActionTypes.SET_LIMIT:
            return {
                ...state,
                guestsLimit: action.payload === "UNLIMITED" /* SchedulerLimit.UNLIMITED */ ? undefined : parseInt(action.payload.replace('LIMIT', '')),
            };
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.meetingType;
        default:
            return state;
    }
};
const availability = (state = exports.initialState.availability, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.SET_AVAILABILITY:
            return action.payload;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.availability;
        default:
            return state;
    }
};
const availabilityCustom = (state = exports.initialState.availabilityCustom, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.SET_AVAILABILITY_CUSTOM:
            return action.payload;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.availabilityCustom;
        default:
            return state;
    }
};
const availabilityRange = (state = exports.initialState.availabilityRange, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.UPDATE_AVAILABILITY_RANGE:
            return { ...state, ...action.payload };
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.availabilityRange;
        default:
            return state;
    }
};
const availabilityRollingWindow = (state = exports.initialState.availabilityRollingWindow, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.SET_AVAILABILITY_ROLLING_WINDOW:
            return action.payload;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.availabilityRollingWindow;
        default:
            return state;
    }
};
const availabilityRollingExpiration = (state = exports.initialState.availabilityRollingExpiration, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.SET_AVAILABILITY_ROLLING_EXPIRATION:
            return action.payload;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.availabilityRollingExpiration;
        default:
            return state;
    }
};
const limit = (state = exports.initialState.limit, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.SET_LIMIT:
            return action.payload;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.limit;
        default:
            return state;
    }
};
const calendarStartAt = (state = exports.initialState.calendarStartAt, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.SET_CALENDAR_START_AT:
            return action.payload;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.calendarStartAt;
        default:
            return state;
    }
};
const host = (state = exports.initialState.host, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.SET_HOST:
            return action.payload;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.host;
        default:
            return state;
    }
};
const mainGuest = (state = exports.initialState.mainGuest, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.SET_MAIN_GUEST:
            return action.payload;
        case actions_1.SUMO1SchedulerActionTypes.ADD_MEMBERS:
            return (0, reducerUtils_1.updateMemberIfEmailMatches)(state, action.payload);
        case actions_1.SUMO1SchedulerActionTypes.SET_HOST:
            return action.payload?.email && (0, helpers_1.isSameEmail)(state?.email, action.payload?.email) ? null : state;
        case actions_1.SUMO1SchedulerActionTypes.CLEAR_MEMBERS:
            return null;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.mainGuest;
        default:
            return state;
    }
};
const guests = (state = exports.initialState.guests, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.SET_GUESTS:
            return action.payload;
        case actions_1.SUMO1SchedulerActionTypes.ADD_MEMBERS:
            return (0, reducerUtils_1.updateExistingCustomMembersByEmail)(state, action.payload);
        case actions_1.SUMO1SchedulerActionTypes.SET_MAIN_GUEST:
            return action.payload?.email ? state.filter((guest) => !(0, helpers_1.isSameEmail)(guest.email, action.payload?.email)) : state;
        case actions_1.SUMO1SchedulerActionTypes.SET_HOST:
            return action.payload?.email ? state.filter((guest) => !(0, helpers_1.isSameEmail)(guest.email, action.payload?.email)) : state;
        case actions_1.SUMO1SchedulerActionTypes.CLEAR_MEMBERS:
            return [];
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.guests;
        default:
            return state;
    }
};
const upsertAction = (state = exports.initialState.upsertAction, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.SET_UPSERT_ACTION:
            return action.payload;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.upsertAction;
        default:
            return state;
    }
};
const bookAction = (state = exports.initialState.bookAction, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.SET_BOOK_ACTION:
            return action.payload;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.bookAction;
        default:
            return state;
    }
};
const isSchedulerDataFetching = (state = exports.initialState.isSchedulerDataFetching, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.GET_SCHEDULER_DATA_REQUEST:
            return true;
        case actions_1.SUMO1SchedulerActionTypes.GET_SCHEDULER_DATA_SUCCESS:
        case actions_1.SUMO1SchedulerActionTypes.GET_SCHEDULER_DATA_FAILURE:
            return false;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isSchedulerDataFetching;
        default:
            return state;
    }
};
const isWorkspaceDataFetching = (state = exports.initialState.isWorkspaceDataFetching, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.GET_WORKSPACE_DATA_REQUEST:
            return true;
        case actions_1.SUMO1SchedulerActionTypes.GET_WORKSPACE_DATA_SUCCESS:
        case actions_1.SUMO1SchedulerActionTypes.GET_WORKSPACE_DATA_FAILURE:
            return false;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isWorkspaceDataFetching;
        default:
            return state;
    }
};
const isHostScheduleFetching = (state = exports.initialState.isHostScheduleFetching, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.GET_HOST_SCHEDULE_REQUEST:
            return true;
        case actions_1.SUMO1SchedulerActionTypes.GET_HOST_SCHEDULE_SUCCESS:
        case actions_1.SUMO1SchedulerActionTypes.GET_HOST_SCHEDULE_FAILURE:
            return false;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isHostScheduleFetching;
        default:
            return state;
    }
};
const error = (state = exports.initialState.error, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.GET_SCHEDULER_DATA_FAILURE:
        case actions_1.SUMO1SchedulerActionTypes.GET_WORKSPACE_DATA_FAILURE:
            return true;
        case actions_1.SUMO1SchedulerActionTypes.GET_SCHEDULER_DATA_REQUEST:
        case actions_1.SUMO1SchedulerActionTypes.GET_WORKSPACE_DATA_REQUEST:
            return false;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.error;
        default:
            return state;
    }
};
const hostScheduleError = (state = exports.initialState.hostScheduleError, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.GET_HOST_SCHEDULE_FAILURE:
            return true;
        case actions_1.SUMO1SchedulerActionTypes.GET_HOST_SCHEDULE_REQUEST:
            return false;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.hostScheduleError;
        default:
            return state;
    }
};
const isCreateFetching = (state = exports.initialState.isCreateFetching, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.SCHEDULER_UPSERT_INBOX_MEETING_TYPE_REQUEST:
            return true;
        case actions_1.SUMO1SchedulerActionTypes.SCHEDULER_UPSERT_INBOX_MEETING_TYPE_SUCCESS:
        case actions_1.SUMO1SchedulerActionTypes.SCHEDULER_UPSERT_INBOX_MEETING_TYPE_FAILURE:
            return false;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isCreateFetching;
        default:
            return state;
    }
};
const createError = (state = exports.initialState.createError, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.SCHEDULER_UPSERT_INBOX_MEETING_TYPE_FAILURE:
            return action.payload;
        case actions_1.SUMO1SchedulerActionTypes.SCHEDULER_UPSERT_INBOX_MEETING_TYPE_REQUEST:
            return null;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.createError;
        default:
            return state;
    }
};
const isBookFetching = (state = exports.initialState.isBookFetching, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.SCHEDULER_BOOK_INSTANT_MEETING_REQUEST:
            return true;
        case actions_1.SUMO1SchedulerActionTypes.SCHEDULER_BOOK_INSTANT_MEETING_SUCCESS:
        case actions_1.SUMO1SchedulerActionTypes.SCHEDULER_BOOK_INSTANT_MEETING_FAILURE:
            return false;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isBookFetching;
        default:
            return state;
    }
};
const bookError = (state = exports.initialState.bookError, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.SCHEDULER_BOOK_INSTANT_MEETING_FAILURE:
            return action.payload;
        case actions_1.SUMO1SchedulerActionTypes.SCHEDULER_BOOK_INSTANT_MEETING_REQUEST:
            return null;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.bookError;
        default:
            return state;
    }
};
const headerTab = (state = exports.initialState.headerTab, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.SET_HEADER_TAB:
            return action.payload;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.headerTab;
        default:
            return state;
    }
};
const isBookSuccess = (state = exports.initialState.isBookSuccess, action) => {
    switch (action.type) {
        case actions_1.SUMO1SchedulerActionTypes.SET_BOOK_INSTANT_MEETING_SUCCESS:
            return true;
        case actions_1.SUMO1SchedulerActionTypes.RESET_WHOLE_STORE:
            return exports.initialState.isBookSuccess;
        default:
            return state;
    }
};
exports.default = (0, redux_1.combineReducers)({
    schedulerData,
    workspaceData,
    hostSchedule,
    isSettingsOpened,
    showWeekends,
    schedulerParams,
    workspaceId,
    meetingTypeId,
    meetingType,
    availability,
    availabilityCustom,
    availabilityRange,
    availabilityRollingWindow,
    availabilityRollingExpiration,
    limit,
    calendarStartAt,
    host,
    mainGuest,
    guests,
    upsertAction,
    bookAction,
    isSchedulerDataFetching,
    isWorkspaceDataFetching,
    error,
    isHostScheduleFetching,
    hostScheduleError,
    isCreateFetching,
    createError,
    isBookFetching,
    bookError,
    headerTab,
    membersData,
    isFetchingMembers,
    isBookSuccess,
});
